export default __webpack_public_path__ + "static/media/f1.161ef7e1.svg";